import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import IconButton from '@mui/material/IconButton';
import ArrowCircleRightTwoTone from '@mui/icons-material/ArrowCircleRightTwoTone';
import ArrowCircleLeftTwoTone from '@mui/icons-material/ArrowCircleLeftTwoTone';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Copyright from '../../components/Copyright';
import OverlayLoader from '../../components/OverlayLoader';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
registerLocale('es', es);
import { showToast } from '../../utils/toast';
import {
  validateEmail,
  getMysqlDate,
  base64Encode,
  base64Decode,
  sha256Encode,
  formatDate
} from '../../utils/generals';
import { validarNickname, getNicknameRules, getNicknameMaxLength } from '../../utils/nicknameValidator';
import HttpClient from '../../helpers/HttpClient'; 


import 'react-datepicker/dist/react-datepicker.css';
import './styles.scss';

export default function SignUp() {
  const range = (start, end) => {
    var ans = [];
    for (let i = start; i <= end; i++) {
      ans.push(i);
    }
    return ans;
  };
  const getYear = (date) => {
    return date.getYear();
  };
  const years = range(1920, new Date().getFullYear() + 1, 1);
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Novimbre',
    'Diciembre',
  ];

  const [open, setOpen] = React.useState(false);
  const [ready, setReady] = React.useState(false);
  const navigate = useNavigate();
  const [startDate, setStartDate] = React.useState(new Date());

  const [isOpen, setIsOpen] = React.useState(false);
  const handleChange = (e) => {
    setIsOpen(false);
    setStartDate(e);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };

  const [phoneValue, setPhoneValue] = React.useState('');
  const [phoneError, setPhoneError] = React.useState(false);

  const validarTelefonoInternacional = (phone: string): boolean => {
    if (!phone) return true; // Es opcional
    // Validar formato internacional: debe empezar con + y tener entre 10-15 dígitos
    const phoneRegex = /^\+\d{10,15}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const email = data.get('email').trim().toLowerCase();
    const email_repeat = data.get('email_repeat').trim().toLowerCase();
    const fullName = data.get('fullName').trim();
    const document = data.get('document').trim();
    const password = data.get('password').trim();
    const password_repeat = data.get('password_repeat').trim();
    const pin = data.get('pin').trim();
    const nickname = String(data.get('nickname')).trim();
    let phone = phoneValue;
    // Asegurar que el teléfono tenga + si existe
    if (phone) {
      const phoneStr = String(phone).trim();
      if (!phoneStr.startsWith('+')) {
        phone = '+' + phoneStr;
      } else {
        phone = phoneStr;
      }
    }
    const birthday = startDate ? formatDate(startDate) : '';

    if (
      email == '' ||
      email_repeat == '' ||
      password_repeat == '' ||
      password == '' ||
      fullName == '' ||
      document == '' ||
      birthday == "" ||
      pin == "" ||
      nickname == ""
    ) {
      showToast('Completa los datos');
    } else {
      const validacionNickname = validarNickname(nickname);
      if (!validacionNickname.valido) {
        showToast(validacionNickname.error || 'Nombre de usuario inválido');
      } else if (!validateEmail(email)) {
        showToast('El correo electrónico no es correcto');
      } else if (email != email_repeat) {
        showToast('Revisa que tu correo electrónico sea válido en ambos campos de texto');
      } else if (password != password_repeat) {
        showToast('Revisa que tu contraseña sea la misma en ambos campos de texto');
      } else if (phone && !validarTelefonoInternacional(phone)) {
        showToast('Teléfono inválido. Debe ser formato internacional: +57 3001234567');
      } else {
        setOpen(true);

        const registerRequest = await HttpClient().post(`/user/save`, {
          fullName: fullName,
          document: document,
          email: email,
          birthday: birthday,
          password: password,
          password_repeat: password_repeat,
          pin: pin,
          nickname: nickname,
          celular: phone
        });
        setOpen(false);
        if (registerRequest.error) {
          showToast('Revisa que el correo o documento de usuario no exista dentro de la app. Valida que tu pin sea válido', 'error');
        } else {
          setReady(true);
          showToast(
            'Usuario creado exitosamente. De click en el botón o cierre el mensaje para ir a la pantalla de inico de sesión',
            'success',
            undefined,
            () => {
              navigate('/login');
            }
          );
        }
      }
    }
  };

  const CloseButton = ({ closeToast }) => (
    <Chip
      label="Iniciar sesión"
      variant="outlined"
      onClick={() => {
        closeToast();
        setOpen(false);
        navigate('/login');
      }}
    />
  );

  return (
    <Container component="main" maxWidth="sm">
      <OverlayLoader
        open={open}
        ready={ready}
        buttonClick={() => {
          setOpen(false);
          navigate('/login');
        }}
      />
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        className='register-center'
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Registro de usuario
        </Typography>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                autoComplete="off"
                name="fullName"
                required
                fullWidth
                id="fullName"
                label="Nombre completo"
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                autoComplete="off"
                name="nickname"
                required
                fullWidth
                id="nickname"
                label="Nombre de usuario"
                helperText={getNicknameRules()}
                inputProps={{
                  maxLength: getNicknameMaxLength(),
                  pattern: '[a-zA-Z0-9._\\-]*'
                }}
              />
            </Grid>
            <Grid item xs={12}>
            <TextField
                autoComplete="off"
                name="birthday"
                required
                fullWidth
                id="birthday"
                label="Fecha de nacimiento"
                onClick={handleClick}
                value={formatDate(startDate)}
                inputProps={
                  { readOnly: true, }
                }
              />
              {isOpen ? (
              <DatePicker
                inline
                locale="es"
                dateFormat="yyyy-MM-dd"
                selected={startDate}
                onChange={(date) => handleChange(date)}
                maxDate={new Date()}
                renderCustomHeader={({
                  date,
                  changeYear,
                  changeMonth,
                  decreaseMonth,
                  increaseMonth,
                  prevMonthButtonDisabled,
                  nextMonthButtonDisabled,
                }) => (
                  <div
                    style={{
                      margin: 10,
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <IconButton
                      color="secondary"
                      onClick={decreaseMonth}
                      disabled={prevMonthButtonDisabled}
                    >
                      <ArrowCircleLeftTwoTone />
                    </IconButton>
                    <select
                      value={date.getFullYear()}
                      onChange={({ target: { value } }) => changeYear(value)}
                    >
                      {years.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    <select
                      value={months[date.getMonth()]}
                      onChange={({ target: { value } }) =>
                        changeMonth(months.indexOf(value))
                      }
                    >
                      {months.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    <IconButton
                      color="secondary"
                      onClick={increaseMonth}
                      disabled={nextMonthButtonDisabled}
                    >
                      <ArrowCircleRightTwoTone />
                    </IconButton>
                  </div>
                )}
              />
              ):(null)}
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="document"
                label="Documento"
                name="document"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email"
                label="Correo electrónico"
                name="email"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email_repeat"
                label="Confirmación correo electrónico"
                name="email_repeat"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="phone"
                label="Celular/WhatsApp (opcional)"
                id="phone"
                placeholder="+57 (código país) número"
                autoComplete="off"
                value={phoneValue}
                error={phoneError}
                helperText={phoneError ? "Formato inválido. Usa: +57 3001234567" : "Formato internacional: +57 3001234567"}
                onChange={(e) => {
                  const input = e.target as HTMLInputElement;
                  let value = input.value;
                  // Permite + seguido de dígitos (formato internacional)
                  value = value.replace(/[^\d+]/g, "");
                  // Si no comienza con +, agregarlo automáticamente si está vacío
                  if (value && !value.startsWith("+")) {
                    value = "+" + value;
                  }
                  // Limitar a máximo 15 dígitos (estándar E.164) + el símbolo +
                  if (value.startsWith("+")) {
                    const digits = value.slice(1);
                    if (digits.length > 15) {
                      value = "+" + digits.slice(0, 15);
                    }
                  }
                  setPhoneValue(value);
                  // Validar en tiempo real
                  if (value && !validarTelefonoInternacional(value)) {
                    setPhoneError(true);
                  } else {
                    setPhoneError(false);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="new-password"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="password_repeat"
                label="Contraseña"
                type="password"
                id="password_repeat"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="pin"
                label="Pin"
                id="pin"
                autoComplete="off"
              />
            </Grid>
            {/*<Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox value="allowExtraEmails" color="primary" />}
                label="Acepto los terminos y condiciones."
              />
                      </Grid>*/}
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Registrar
          </Button>
          <Grid container>
            <Grid item sx={{margin: "auto"}}>
              <Link
                component="button"
                variant="body2"
                onClick={() => {
                  navigate('/login');
                }}
              >
                Iniciar sesión
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/*<Copyright sx={{ mt: 5 }} />*/}
      {/*<ToastContainer limit={3} autoClose={3000} />*/}
    </Container>
  );
}
